import { useQuery, useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type {
  AiInsights,
  AiSuggestionsResponse,
  DashboardAiSuggestion,
  AiSummary,
} from '@/lib/types'

export function useContactInsights(contactId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['ai', 'insights', contactId],
    queryFn: () => api<AiInsights>(`/api/contacts/${contactId}/ai/insights`),
    enabled: !!contactId && enabled,
    staleTime: 1000 * 60 * 10, // 10 min — AI calls are expensive
    retry: false,
  })
}

export function useContactSuggestions(contactId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['ai', 'suggestions', contactId],
    queryFn: () => api<AiSuggestionsResponse>(`/api/contacts/${contactId}/ai/suggestions`),
    enabled: !!contactId && enabled,
    staleTime: 1000 * 60 * 10,
    retry: false,
  })
}

export function useDashboardSuggestions() {
  return useQuery({
    queryKey: ['ai', 'dashboard-suggestions'],
    queryFn: () => api<{ suggestions: DashboardAiSuggestion[] }>('/api/dashboard/ai/suggestions'),
    staleTime: 1000 * 60 * 10,
    retry: false,
  })
}

export function useSummarize() {
  return useMutation({
    mutationFn: (data: {
      type: 'interaction' | 'voice_note' | 'relationship'
      sourceIds?: string[]
      contactId?: string
    }) => api<AiSummary>('/api/ai/summarize', { method: 'POST', body: JSON.stringify(data) }),
  })
}
